import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_TEXT, CONTENT_TYPE_IMAGE, CONTENT_CATEGORY_DOCUMENT} from '../../constants';

export default {
  id: 'DOSSIER',
  title: 'Comment est organisé un dossier en ligne ?',
  description: '',
  categories: [CONTENT_CATEGORY_DOCUMENT],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    value: 'Vos documents sont répartis en plusieurs sous dossiers :'
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Légal :  vous y trouverez les documents obligatoires qui constituent le Quitus Légal'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_DOSSIER/FR_DOSSIER_1.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Métier : vous y trouverez tous les autres documents liés à votre secteur d’activité dans le cadre d’un contrat de sous-traitance'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_DOSSIER/FR_DOSSIER_2.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Additionnel : vous y trouverez les documents complémentaires à votre dossier'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_DOSSIER/FR_DOSSIER_3.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Opérations : vous y trouverez tous les documents relatifs à une opération (Attestation Décennale Nominative, Charte RSE…)'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_DOSSIER/FR_DOSSIER_4.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'En face de chaque document vous retrouvez le statut du document.'
  }]
};
